<template>
  <div class="styleCard">

    <ul class="style-nav style2">
      <li
        v-for="tab in analogiesTabs"
        :key="tab.id"
        :class="{ active: selectedAnalogyTab === tab.alias }"
        @click="selectedAnalogyTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div class="analogies-cont" v-if="selectedAnalogyTab === 'ANSWERS'">
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Occupation</th>
              <th>~Analogy</th>
            </tr>
          </thead>
          <tr
            v-for="row in dictionaries.general.client_questions[0].answers"
            :key="row"
          >
            <td class="td-occ" v-if="row.analogy !== null">{{ row.answer }}</td>
            <td class="td-analogy" v-if="row.analogy !== null">
              {{ row.analogy }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="analogies-cont" v-if="selectedAnalogyTab === 'ANALOGY'">
      <h4>~Analogy~</h4>
      <p>~ Same as your body needs 3 meals a day then one big meal</p>
      <p>
        ~ Concert: Violin can create only one sound, if you're going to add a
        piano and drums and guitar you will have An Amazing Concert and Harmony
      </p>
      <p>
        ~ If you want to prepare dinner, you have a different set of pants for
        each different type of food Knifes, each knife is for different
        preparation of food
      </p>
      <p>
        ~ Pizza: You have Domino's you have Pizza hut – same pizza, But I like
        Domino's
      </p>
      <p>
        ~ Shoes, sleepers, running shoes heels. each one has different purpose,
        but you can walk in everyone
      </p>
      <p>
        ~ If you had 1M usd would you put it in one bank? or you going to split
        it in several banks?
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "Analogies.component",
  components: {},

  sockets: {
    receiveNotifyStats(data) {
      this.notifyMessages = data;
    },
    receiveMsgStats(data) {
      this.messages = data;
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "transferConfirmAnswer"
    ]),
    ...mapState("main", ["showVikiMsg"])
  },

  data() {
    return {
      messages: [],
      notifyMessages: [],
      selectedAnalogyTab: "ANALOGY",
      analogiesTabs: [
        {
          id: 1,
          name: "ANALOGY",
          alias: "ANALOGY"
        },
        {
          id: 2,
          name: "ANSWERS ANALOGIES",
          alias: "ANSWERS"
        }
      ]
    };
  },
  created() {},
  methods: {
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY");
    }
  }
};
</script>

<style scoped>
.root {
  width: 90%;
  margin: auto;
}
.card-body {
  padding: 10px;
}
.card-header {
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
}
.td-users-ms {
  width: 100px;
}
.floating-wrapper {
  position: relative;
}
.w50 {
  width: calc(50% - 0.2rem);
}
.left {
  float: left;
}
.margin {
  margin: 0.5rem;
}
.margin_r_hf {
  margin-right: 0.2rem;
}
.margin_l_c {
  margin-left: 0;
}

.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  width: 97%;
  position: absolute;
  margin: auto auto 10px auto;
  top: 90px;
  right: 0;
  left: 0;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
          background: white;
        */
}
.style-nav.style2 li {
  /*border-radius: 3px 3px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.form-body {
  padding: 20px;
  background-color: white;
}
.form-body form {
  margin-bottom: 20px;
}
.bttn {
  font-family: Montserrat;
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}
.analogies-cont {
  padding: 10px;
}

.table {
  background: white;
  margin-bottom: 0;
}
.table th {
  padding-left: 10px;
}
.table tr {
  border-top: solid 1px #eff3f6;
}
.table .td-occ {
  width: 170px;
  padding-left: 10px;
}

.table .td-analogy {
  width: max-content;
  word-break: break-word;
  font-size: 13px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
